const debtor_group = {
	add_button: "Debiteur toevoegen",
	add_debtor_dialog: {
		description: "Debiteur toevoegen",
		form: {
			debtor_code: "Debiteur code",
		},
		title: "Debiteur toevoegen",
	},
	delete_dialog: {
		description: "Wilt u debiteur <strong>{{name}}</strong> echt ontkoppelen?",
		title: "Debiteur ontkoppelen",
	},
	status: {
		add_debtor: {
			success:
				"Debiteur <strong>{{debtor_code}}</strong> succesvol toegevoegd aan de debiteurgroep.",
			unknown:
				"De gekozen debiteur kan op dit moment niet worden toegevoegd. Probeert u het later opnieuw.",
		},
		delete_debtor: {
			not_empty: "Debiteur groep niet leeg, ontkoppel eerst alle Debiteuren",
			success: "Debiteur succesvol verwijderd uit de debiteurgroep.",
			unknown:
				"De gekozen debiteur kan op dit moment niet worden verwijderd. Probeert u het later opnieuw.",
		},
	},
	title: "Debiteurgroep",
};

export default debtor_group;
